export enum CountryCode {
  AL = 'AL',
  AD = 'AD',
  BE = 'BE',
  BA = 'BA',
  BG = 'BG',
  CY = 'CY',
  DK = 'DK',
  EE = 'EE',
  FI = 'FI',
  FR = 'FR',
  GR = 'GR',
  IE = 'IE',
  IS = 'IS',
  IT = 'IT',
  HR = 'HR',
  LV = 'LV',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MT = 'MT',
  MD = 'MD',
  MC = 'MC',
  ME = 'ME',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RU = 'RU',
  SM = 'SM',
  CH = 'CH',
  RS = 'RS',
  SK = 'SK',
  SI = 'SI',
  ES = 'ES',
  GB = 'GB',
  SE = 'SE',
  CZ = 'CZ',
  TR = 'TR',
  DE = 'DE',
  UA = 'UA',
  HU = 'HU',
  VA = 'VA',
  BY = 'BY',
  AT = 'AT',
}
